// extracted by css-extract-rspack-plugin
export default {"cls1":"VideoResults-cls1_QV7","cls2":"VideoResults-cls2_ZtD VideoResults-cls1_QV7"};